module.exports = __webpack_public_path__ + "img/4b9066a.jpg";